<template>
<div class="chapter">
<div class="inner_page">
<div class="titlepage">
<h1 class="title">Black Greek-Letter Organizations<br/>in the Twenty-first Century</h1>
<p class="nonindent"><span class="big">Our Fight Has Just Begun</span><br/><br/><br/><br/><br/><br/></p>
<p class="nonindent"><em>Edited by</em><br/>Gregory S. Parks<br/><br/><br/><br/><br/><br/><br/><br/><br/></p>
<p class="nonindent"><img alt="" src="OEBPS/images/9780813172958_logo1.png"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780813172958_epub_tp_r1.vue?43f91deb